(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["orangie-looks"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('orangie-looks-carousel')) {
  customElements.define('orangie-looks-carousel', class extends HTMLElement {
    connectedCallback() {
      if (!this.hasAttribute('data-carousel')) return;
      this.track = this.querySelector('.orangie-looks__carousel');
      this.controls = this.querySelector('.orangie-looks__controls');
      this.previous = this.querySelector('[data-previous]');
      this.next = this.querySelector('[data-next]');
      if (!this.track || !this.controls) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      const update = () => {
        const max = this.track.scrollWidth - this.track.clientWidth;
        const position = Math.abs(this.track.scrollLeft);
        this.controls.hidden = max < 2;
        this.previous.disabled = position < 2;
        this.next.disabled = position >= max - 2;
      };
      const move = (step) => {
        const card = this.track.querySelector('.orangie-look');
        if (!card) return;
        const distance = card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap);
        this.track.scrollBy({ left: -step * distance, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      };
      this.previous.addEventListener('click', () => move(-1), options);
      this.next.addEventListener('click', () => move(1), options);
      this.track.addEventListener('scroll', update, { ...options, passive: true });
      this.resize = new ResizeObserver(update);
      this.resize.observe(this.track);
      update();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.resize?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
